<bw-action-article-legacy
  class="autosave-settings"
  [brightsideWebFb]="{ event_name: 'autosave_select' }"
  *ngIf="simpleSelectorVal$ | async as amountSelected; else spinner"
>
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'autosave_select' }"
      (exitActionHandler)="routeUserOnBack()"
    ></ui-nav-exit-back>
  </div>
  <div header-title>
    <typography-legacy title-large color="var(--primary-text)">
      {{ autoSaveTitle | translate }}
    </typography-legacy>
  </div>
  <div content-section>
    <div class="autosave-settings__content-section">
      <typography-legacy text-small-regular color="var(--secondary-text)" class="mb-sm">
        {{ autoSaveDescription | translate }}
      </typography-legacy>

      <ng-container *ngIf="options$ | async as options">
        <bw-bui-tile-legacy
          *ngFor="let option of options"
          tileHeight="72px"
          tileWidth="400px"
          tileMargin="0 0 8px 0"
          [tileBorder]="option.value === amountSelected ? '1px solid #005fff' : '1px solid #f2f7ff'"
        >
          <bui-tile-card-legacy
            tabindex="0"
            (click)="autosaveAmount(option.value)"
            (keyup.enter)="autosaveAmount(option.value)"
            cardBackground="var(--bg-blue)"
          >
            <bw-bui-row-legacy rightIconName="checkmark" [rightIconColor]="option.value === amountSelected ? '#005fff' : '#757575'">
              <div class="row-content">
                <bw-bui-column-legacy
                  [rowSpacing]="4"
                  [rows]="[
                    {
                      type: 'label',
                      content: option.value !== recommendedValue ? '' : ('RECOMMENDED' | translate),
                      color: option.value === amountSelected ? 'var(--blue-50)' : 'var(--primary-text)'
                    },
                    {
                      type: 'detail',
                      content: 'AUTOSAVE_SELECT_AMOUNT' | translate : { amount: option.value },
                      color: option.value === amountSelected ? 'var(--blue-50)' : 'var(--primary-text)'
                    }
                  ]"
                >
                </bw-bui-column-legacy>
              </div>
            </bw-bui-row-legacy>
          </bui-tile-card-legacy>
        </bw-bui-tile-legacy>
      </ng-container>
    </div>
  </div>
  <div footer-actions>
    <button
      bw-button-legacy
      type="submit"
      [brightsideWebFb]="{ event_name: 'autosave_select' }"
      (click)="onSubmit()"
      [processing]="processing$ | async"
    >
      {{ 'AUTOSAVE_SELECT_CTA1' | translate : { amount: amountSelected } }}
    </button>
    <button bw-link-button-legacy (click)="chooseOwn()" [brightsideWebFb]="{ event_name: 'autosave_select' }" [secondaryCta]="true">
      {{ 'AUTOSAVE_SELECT_CTA2' | translate }}
    </button>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
